"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialCaract = void 0;
var MaterialCaract = /** @class */ (function () {
    function MaterialCaract(_a) {
        var _b = _a._id, _id = _b === void 0 ? { m: '', c: '', V: '' } : _b, _c = _a.CD_CARACT, CD_CARACT = _c === void 0 ? '' : _c, _d = _a.VAL_CARACT, VAL_CARACT = _d === void 0 ? '' : _d, _e = _a.CD_MATERIAL, CD_MATERIAL = _e === void 0 ? '' : _e, _f = _a.materialCarac, materialCarac = _f === void 0 ? { m: '', c: '' } : _f;
        this._id = _id;
        this.CD_CARACT = CD_CARACT;
        this.VAL_CARACT = VAL_CARACT;
        this.CD_MATERIAL = CD_MATERIAL;
        this.materialCarac = materialCarac;
    }
    return MaterialCaract;
}());
exports.MaterialCaract = MaterialCaract;
//# sourceMappingURL=MaterialCaract.js.map